import {
  Avatar,
  Button,
  Col,
  Form,
  Row,
  Space,
  message,
  notification,
} from "antd";
import {InputFields, ModalCustom} from "components/common";
import Icon from "assets/icons";
import React, {useEffect, useRef, useState} from "react";
import {fields as fieldsInit} from "./config";
import {ReactComponent as PaidSVG} from "assets/images/svg/paid.svg";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {LOAI_DON_THUOC, tabKeys} from "types/enums";
import {medicineStoreService} from "api";
import {
  convertIosStringToDateDayjs,
  convertIosStringToDateObjectDayjs,
  formatDateToString,
  isValuable,
} from "helper/common";
import {
  getListPatientAPI,
  setActiveTabPresciption,
  setDetailRecord,
  setEnableSLHoanTra,
  setLoading,
  setSearchForm,
  setShowHoanLai,
} from "redux/reducer/medicineStore";
import {setActiveKey, setIdReceiptPrint} from "redux/reducer/common";
import {FieldsSclera1} from "pages/Examination/components/InforDetail/DetailTabInfo/components/ExamTab/components/ScleraExpand/ScleraExpand.config";
import Notification from "components/common/notification/notification";
import PresModal from "../PresModal/PresModal";
import BillModal from "../BillModal/BillModal";
import ExamOutModal from "components/common/PrintReceipt/ExamOutModal/ExamOutModal";
import {setIdReceiptExamOut} from "redux/reducer/examination";
import ReturnModal from "../ReturnModal/ReturnModal";
import PatientInfoCommon from "components/common/PatientInfoCommon/PatientInfoCommon";

const PatienPrescription = props => {
  const {listMedicineRef} = props;
  const dispatch = useAppDispatch();
  const reduceRef = useAppSelector(state => state.medicineStore.reduceRef);
  const listPatient = useAppSelector(state => state.medicineStore.listPatient);
  const presRef = useRef<any>();
  const billRef = useRef<any>();
  const returnRef = useRef<any>();
  const examOutRef = useRef<any>();
  const [form] = Form.useForm();
  const [fields, setFields] = useState<any[]>(fieldsInit);
  const searchParams = useAppSelector(state => state.medicineStore.searchForm);
  const loading = useAppSelector(state => state.medicineStore.loading);
  const showHoanLai = useAppSelector(state => state.medicineStore.showHoanLai);
  const detailRecord = useAppSelector(
    state => state.medicineStore.detailRecord
  );
  const enableSLHoanTra = useAppSelector(
    state => state.medicineStore.enableSLHoanTra
  );
  const typePrescription = useAppSelector(
    state => state.medicineStore.typePrescription
  );
  // Lấy danh sách hình thức thanh toán

  const getListPayments = async () => {
    try {
      const res = await medicineStoreService.getListPayments();

      const optionsPayments = res.data.map(e => ({
        value: e.id,
        label: e.name,
      }));
      fields.find(e => e.name == "paymentsId").options = optionsPayments;

      setFields([...fields]);
    } catch (error) {
      Notification("error", "Đã có lỗi khi lấy danh sách hình thức thanh toán");
    }
  };
  // tìm kiếm
  const setOnSearch = () => {
    fields.find(e => e.name == "hoTen").onSearch = e => {};
    fields.find(e => e.name == "hoTen").onChange = e => {
      setSelectedPatient(e);
    };
    setFields([...fields]);
  };
  const setSelectedPatient = id => {
    const selectedPatient = listPatient.find(
      e => e?.id?.toString() == id?.toString()
    );
    if (selectedPatient && selectedPatient != undefined) {
      form.setFieldValue("hoTen", selectedPatient?.hoTen);
    }

    form.setFieldValue("maBenhNhan", selectedPatient?.id);
    form.setFieldValue("dienThoai", selectedPatient?.dienThoai);
    form.setFieldValue(
      "gioiTinh",
      selectedPatient?.gioiTinh == 1
        ? "NU"
        : selectedPatient?.gioiTinh == 0
        ? "NA"
        : null
    );
    form.setFieldValue(
      "ngaySinh",
      convertIosStringToDateDayjs(selectedPatient?.ngaySinh)
    );
    form.setFieldValue("diaChi", selectedPatient?.diaChi);
  };
  const setOptions = listPatient => {
    const options = listPatient.map(e => ({
      label: `${e?.hoTen} ${e?.dienThoai ? `- ${e?.dienThoai}` : ""}`,
      value: e?.id,
      key: e?.id,
    }));

    fields.find(e => e.name == "hoTen").options = options;
    setFields([...fields]);
  };

  useEffect(() => {
    getListPayments();

    dispatch(getListPatientAPI(""));
  }, []);

  useEffect(() => {
    setOptions(listPatient);
    setOnSearch();
  }, [listPatient]);
  useEffect(() => {
    if (detailRecord) {
      const prescriptionDto = detailRecord.prescriptionDto;
      const data = {
        ...prescriptionDto,
        ngaySinh: convertIosStringToDateDayjs(prescriptionDto.ngaySinh),
        thoiGianBan: convertIosStringToDateObjectDayjs(
          prescriptionDto?.thoiGianBan
        ),
        nguoiBan: prescriptionDto?.nguoiBan ?? localStorage.getItem("fullName"),
      };
      form.setFieldsValue(data);
    } else {
      form.resetFields();
    }
  }, [detailRecord]);
  useEffect(() => {
    if (typePrescription == LOAI_DON_THUOC.TAO_MOI) {
      form.setFieldValue("thoiGianBan", null);
      form.setFieldValue("id", null);
      form.setFieldValue("status", "CB");
      form.setFieldValue("nguoiBan", localStorage.getItem("fullName"));
    }
  }, [typePrescription, detailRecord]);

  const getDetailPrescription = () => {
    const dataReduce = reduceRef?.getDataReduce();
    const prescriptionDto = {
      ...detailRecord?.prescriptionDto,
      ...form.getFieldsValue(),
      ...dataReduce,
      storeId: 8,
      description: "string",
      ngaySinh: formatDateToString(form.getFieldValue("ngaySinh"), null),
    };
    const listPrescriptionSalesDto = listMedicineRef?.current
      ?.getFieldValue("listPrescriptionSalesDto")
      .map(e => ({
        ...e,
        donViKe: e.donViTinh ?? "",
        soLuongKe: e.soLuong ?? "",
      }));

    const params = {
      prescriptionDto: prescriptionDto,
      listPrescriptionSalesDto: listPrescriptionSalesDto,
    };

    return params;
  };
  const validateForm = async () => {
    try {
      await form.validateFields();

      return true;
    } catch (error) {
      if (error.message) {
        message.warning(error.message);
      }
      return false;
    }
  };
  const validateTable = () => {
    const params = getDetailPrescription();
    if (params.listPrescriptionSalesDto.length <= 0) {
      Notification("error", "Chưa có thuốc trong đơn");
      return false;
    }
    return true;
  };
  const createAndPayPrescription = async () => {
    const validForm = await validateForm();
    const validTable = validateTable();
    if (validForm && validTable) {
      try {
        const params = getDetailPrescription();
        dispatch(setLoading(true));
        dispatch(setSearchForm({...searchParams, limit: 10, page: 1}));
        const res = await medicineStoreService.createAndPayPrescription(params);
        notification.success({message: "Thanh toán thành công "});
        dispatch(setLoading(false));
        dispatch(setActiveKey(tabKeys.MEDICINE_STORE.LIST_PRESCRIPTION));
        dispatch(setActiveTabPresciption(tabKeys.MEDICINE_STORE.LIST_2));
        dispatch(setDetailRecord(res));
      } catch (error) {
        Notification("error", error.response.data);
        dispatch(setLoading(false));
      }
    }
  };
  const returnMedicine = async () => {
    const validTable = validateTable();
    if (!showHoanLai || !enableSLHoanTra) {
      dispatch(setShowHoanLai(true));
      dispatch(setEnableSLHoanTra(true));
    } else if (validTable) {
      try {
        const params = getDetailPrescription();
        dispatch(setLoading(true));
        dispatch(setSearchForm({...searchParams, limit: 10, page: 1}));
        const res = await medicineStoreService.returnMedicine(params);
        dispatch(setDetailRecord(res));
        Notification("success", "Đã lưu thông tin hoàn trả thuốc");
        dispatch(setLoading(false));
        // dispatch(setActiveKey(tabKeys.MEDICINE_STORE.LIST_PRESCRIPTION));
        // dispatch(setActiveTabPresciption(tabKeys.MEDICINE_STORE.LIST_2));
      } catch (error) {
        Notification("error", error.response.data);
        dispatch(setLoading(false));
      }
    }
  };
  return (
    <div className="patient-prescription-info">
      <Space direction="vertical" size={"middle"} style={{width: "100%"}}>
        <Form labelAlign="left" form={form}>
          <Row style={{width: "100%"}}>
            <PatientInfoCommon
              data={{...detailRecord, anh: detailRecord?.prescriptionDto?.anh}}
              fields={fields}
              showHeader={false}
            />
          </Row>
        </Form>

        <Row gutter={[16, 16]} justify={"end"}>
          {detailRecord?.prescriptionDto?.status == "HL" && (
            <Col>
              <Button
                className="btn-sub"
                icon={<Icon.printer />}
                onClick={() => {
                  returnRef?.current.openModal();
                }}
              >
                In phiếu hoàn trả
              </Button>
            </Col>
          )}
          <Col>
            {isValuable(detailRecord?.prescriptionDto?.idPhieuKhamNgoaiTru) && (
              <Button
                className="btn-sub"
                onClick={() => {
                  dispatch(
                    setIdReceiptExamOut(
                      detailRecord?.prescriptionDto?.idPhieuKhamNgoaiTru
                    )
                  );
                  examOutRef?.current.openModal();
                }}
              >
                Xem phiếu khám
              </Button>
            )}
          </Col>
          <Col>
            <Button
              className="btn-sub"
              icon={<Icon.printer />}
              onClick={() => {
                presRef?.current.openModal();
              }}
            >
              In đơn thuốc
            </Button>
          </Col>
          <Col>
            <Button
              className="btn-sub"
              icon={<Icon.printer />}
              onClick={() => {
                billRef?.current.openModal();
              }}
            >
              In hoá đơn
            </Button>
          </Col>
          {typePrescription != LOAI_DON_THUOC.DA_TAO && (
            <Col>
              <Button
                style={{display: "flex", alignItems: "center"}}
                className="btn-sub"
                icon={<PaidSVG style={{paddingRight: "5px"}} />}
                onClick={() => {
                  createAndPayPrescription();
                }}
                loading={loading}
              >
                Thanh toán
              </Button>
            </Col>
          )}
          {typePrescription == LOAI_DON_THUOC.DA_TAO &&
            detailRecord?.prescriptionDto?.status == "DB" && (
              <Button type="primary" onClick={returnMedicine} loading={loading}>
                Hoàn trả thuốc
              </Button>
            )}
        </Row>
      </Space>
      {/* Hoàn trả */}
      <ModalCustom
        wrapClassName="modal-print-form"
        ref={returnRef}
        width={1100}
        centered
      >
        <ReturnModal getDetailPrescription={getDetailPrescription} />
      </ModalCustom>
      {/* Xem phiếu khám ngoại trú */}
      <ModalCustom
        wrapClassName="modal-print-form"
        ref={examOutRef}
        width={1100}
        centered
      >
        <ExamOutModal />
      </ModalCustom>
      {/* In đơn thuốc */}
      <ModalCustom ref={presRef} width={1100} centered>
        <PresModal getDetailPrescription={getDetailPrescription} />
      </ModalCustom>
      {/* Hóa đơn */}
      <ModalCustom
        wrapClassName="modal-print-form"
        ref={billRef}
        width={1100}
        centered
      >
        <BillModal getDetailPrescription={getDetailPrescription} />
      </ModalCustom>
    </div>
  );
};

export default PatienPrescription;
